module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAASElEQVR4Ae3VgQmAAAhE0UZttL9ptUIQwMV74ACiesdrAAAAwPnU9VG13ETLk2h5nVq+iZYPu+Xv1PKLbTknWg67DgAAAH7oBpUxY6elMjYhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Combobox/baseline_arrow_drop_down_black_24dp.png
// module id = 88
// module chunks = 0